import './immobile-content.scss';

/**
 * version    1.0
 * class      <type> (banner)
 * classdesc  Component that manage the immobile content section
 */
export class ImmobileContent {}
